import { Link } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';

/**
 * PÁGINA NÃO ENCONTRADA (23/10/2026, revisão do pesquisador): um endereço que não existe (ex.: /minha-conta) deixava a tela
 * toda branca — nenhuma rota respondia. Agora todo `<Routes>` termina em `path="*"` com esta tela, e o botão leva ao início
 * do papel de quem está entrando (sem sessão, à página inicial).
 */
const INICIO: Record<string, string> = { ADMIN: '/admin', TEACHER: '/teacher', SCHOOL_STAFF: '/gestao', STUDENT: '/student' };

export const PaginaNaoEncontrada = () => {
  const { user } = useAuth();
  const destino = (user?.role && INICIO[user.role]) || '/';
  return (
    <div className="mx-auto max-w-md py-16 text-center" data-testid="pagina-nao-encontrada">
      <p className="font-titulo text-5xl font-bold text-gray-500" aria-hidden>404</p>
      <h1 className="font-titulo mt-4 text-2xl font-bold text-tinta" data-testid="titulo-da-tela">Página não encontrada</h1>
      <p className="mt-2 text-sm text-gray-600">O endereço não existe no portal, ou mudou de lugar.</p>
      <Link to={destino} className="mt-6 inline-flex min-h-[44px] items-center justify-center rounded-md bg-marca-600 px-5 font-medium text-white hover:bg-marca-700" data-testid="voltar-ao-inicio">
        Ir para o início
      </Link>
    </div>
  );
};

export default PaginaNaoEncontrada;
